import type { ClickReleaseConfig } from '../config/types';
import { Indicator } from '../surfaces/indicator';

export interface AttachHandle {
  target: Element;
  indicator: Indicator;
  detach(): void;
}

/**
 * Attach an unread badge to the first element matching `selector` and open the changelog when the
 * element is clicked. Returns a handle (or `null` if nothing matched).
 */
export function attachIndicator(root: ShadowRoot, selector: string, config: ClickReleaseConfig, onClick: () => void): AttachHandle | null {
  const matches = document.querySelectorAll(selector);
  if (matches.length === 0) {
    console.warn(`[clickrelease] attach: no element matches "${selector}"`);
    return null;
  }
  if (matches.length > 1) {
    console.warn(`[clickrelease] attach: "${selector}" matched ${matches.length} elements; using the first`);
  }
  const target = matches[0] as Element;

  const indicator = new Indicator(root, target, config);
  const onTargetClick = (event: Event) => {
    event.preventDefault();
    onClick();
  };
  target.addEventListener('click', onTargetClick);

  return {
    target,
    indicator,
    detach() {
      target.removeEventListener('click', onTargetClick);
      indicator.destroy();
    },
  };
}
